import actionTypes from '../actions/reduxActions/actionTypes';
import { set, lensProp } from 'ramda';

// User notifications are application wide notifications across all tenants.
// Currently used for events such as tenant creation, password reset etc.

// User notifications are not the type of short lived notification
// showing success messages and validation errors etc.

/*
Example user notification:
{
    "content": "A missing value was referenced in the macro element with the ID 49d4c08e-45fa-d976-2bd9-e594b5f0983d...,
    "createdAt": "2019-07-09T15:51:22.873713+00:00",
    "id": "423f4628-1ba3-494e-8fb8-c7d99f8bb662",
    "subject": "Fault",
    "tenant": {
        "developerName": "@DSQA+manywho.com",
        "id": "b32715f9-c7c1-4ea4-b3b0-a75aa8d3e095"
    },
    "type": "fault",
    "userId": "7fae3ab8-330e-409f-b813-1a088420b3b2"
}
*/

const initialState = {
    isLoading: false,
    list: [],
};

const userNotifications = (state = initialState, { type, payload, error, meta }) => {

    switch (type) {

    case actionTypes.USER_NOTIFICATIONS_LOADING:

        return {
            ...state,
            isLoading: true,
        };

    case actionTypes.USER_NOTIFICATIONS_SET:

        return {
            isLoading: false,
            list: payload,
        };

    case actionTypes.USER_NOTIFICATIONS_UPDATE_SINGLE:

        return {
            ...state,
            // Replace the notification in the list with the notification given
            list: state.list.map(notification => notification.id === payload.id ? payload : notification),
        };

    case actionTypes.USER_NOTIFICATIONS_UPDATE_ALL:

        return {
            ...state,
            // Set isRead on all the notifications to true
            list: state.list.map(notification => set(lensProp('isRead'), true, notification)),
        };

    default:
        return state;
    }
};

export default userNotifications;
